/**
 * Hook for container packing actions (scan, bulk create, create, close, reopen, delete, reset, resetAndReturn, update type)
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { containerScan, containerBulkCreate, containerCreate, containerClose, containerReopen, containerDelete, containerReset, containerResetAndReturn, containerUpdate, containerUpdateType, selectShipmentId, containerBulkClose } from '../../redux/packing';
export var useContainerActions = function () {
    var dispatch = useDispatch();
    var shipmentId = useSelector(selectShipmentId);
    var handleContainerScan = useCallback(function (params) { return __awaiter(void 0, void 0, Promise, function () {
        var result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(containerScan({
                            shipmentId: shipmentId,
                            scanInput: params.scanInput,
                            packIntoContainerId: params.packIntoContainerId,
                            parentContainerId: params.parentContainerId,
                            containerTypeEnumId: params.containerTypeEnumId,
                            quantity: (_a = params.quantity) !== null && _a !== void 0 ? _a : 1,
                            serialNumber: params.serialNumber
                        })).unwrap()];
                case 1:
                    result = _b.sent();
                    return [2 /*return*/, result];
            }
        });
    }); }, [dispatch, shipmentId]);
    var handleBulkCreateContainers = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(containerBulkCreate(__assign({ shipmentId: shipmentId }, params))).unwrap()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, [dispatch, shipmentId]);
    var handleCreateContainer = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(containerCreate({
                            shipmentId: shipmentId,
                            containerTypeEnumId: params.containerTypeEnumId,
                            parentContainerId: params.parentContainerId
                        })).unwrap()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, [dispatch, shipmentId]);
    var handleBulkCloseContainers = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(containerBulkClose({
                            shipmentId: shipmentId,
                            containerIds: params.containerIds,
                            shipmentBoxTypeId: params.shipmentBoxTypeId,
                            weight: params.weight,
                            weightUomId: params.weightUomId
                        })).unwrap()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, [dispatch, shipmentId]);
    var handleCloseContainer = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(containerClose({
                            shipmentId: shipmentId,
                            containerId: params.containerId,
                            shipmentBoxTypeId: params.shipmentBoxTypeId,
                            weight: params.weight,
                            weightUomId: params.weightUomId
                        })).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    var handleReopenContainer = useCallback(function (containerId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(containerReopen({ shipmentId: shipmentId, containerId: containerId })).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    var handleDeleteContainer = useCallback(function (containerId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(containerDelete({ shipmentId: shipmentId, containerId: containerId })).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    var handleResetContainer = useCallback(function (containerId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(containerReset({ shipmentId: shipmentId, containerId: containerId })).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    var handleResetAndReturnContainer = useCallback(function (containerId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(containerResetAndReturn({ shipmentId: shipmentId, containerId: containerId })).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    var handleUpdateContainerType = useCallback(function (containerId, containerTypeEnumId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(containerUpdateType({ shipmentId: shipmentId, containerId: containerId, containerTypeEnumId: containerTypeEnumId })).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    var handleUpdateContainer = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(containerUpdate(__assign({ shipmentId: shipmentId }, params))).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    return {
        handleContainerScan: handleContainerScan,
        handleBulkCreateContainers: handleBulkCreateContainers,
        handleCreateContainer: handleCreateContainer,
        handleBulkCloseContainers: handleBulkCloseContainers,
        handleCloseContainer: handleCloseContainer,
        handleReopenContainer: handleReopenContainer,
        handleDeleteContainer: handleDeleteContainer,
        handleResetContainer: handleResetContainer,
        handleResetAndReturnContainer: handleResetAndReturnContainer,
        handleUpdateContainerType: handleUpdateContainerType,
        handleUpdateContainer: handleUpdateContainer
    };
};
export default useContainerActions;
